"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for firebase not found responses for users
 * @param {string} userId
 */
class FirebaseUserNotFoundError extends client_library_1.ExtendableError {
    constructor(userId) {
        super(`User not found in firebase ${userId}`);
        this.userId = userId;
    }
}
exports.default = FirebaseUserNotFoundError;
